var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./projectTypesResponsibles.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ff591e1c\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./projectTypesResponsibles.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/responsibles/learning/components/projectTypesResponsibles.vue
// module id = 758
// module chunks = 0